import FileSaver from "file-saver";
const  stringToTxt = {
    getTxt(data,title='curdr'){
        let str = new Blob([data], { type: "text/plain;charset=utf-8" })
        FileSaver.saveAs(str, title+'.txt')
    }
}

export default stringToTxt;